import { useState } from 'react';
import T from '@wojtekmaj/react-t';

import { Button, List, ListItem, Wrapper } from './button_tabs.styles';

type ButtonTabsProps<T extends string | number> = {
  onChange?: (nextValue: T) => void;
  tabs: readonly {
    label: string;
    value: T;
  }[];
  value?: T;
};

export default function ButtonTabs<T extends string | number>({
  onChange: onChangeProps,
  tabs,
  value: valueProps,
}: ButtonTabsProps<T>) {
  const [valueWithDefault, setValueWithDefault] = useState<T>();

  const onChange = onChangeProps ?? setValueWithDefault;
  const value = valueProps ?? valueWithDefault;

  return (
    <Wrapper>
      <List>
        {tabs.map((option) => (
          <ListItem key={option.value}>
            <Button
              aria-selected={value === option.value ? 'true' : undefined}
              onClick={() => {
                if (onChange) {
                  onChange(option.value);
                }
              }}
            >
              <T>{option.label}</T>
            </Button>
          </ListItem>
        ))}
      </List>
    </Wrapper>
  );
}
